import { render, staticRenderFns } from "./Item1.vue?vue&type=template&id=ae10c4ce&scoped=true"
import script from "./Item1.vue?vue&type=script&lang=js"
export * from "./Item1.vue?vue&type=script&lang=js"
import style0 from "./Item1.vue?vue&type=style&index=0&id=ae10c4ce&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae10c4ce",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/stage.cashnow.d-resources.com/releases/67404460/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ae10c4ce')) {
      api.createRecord('ae10c4ce', component.options)
    } else {
      api.reload('ae10c4ce', component.options)
    }
    module.hot.accept("./Item1.vue?vue&type=template&id=ae10c4ce&scoped=true", function () {
      api.rerender('ae10c4ce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/deliveryNotes/Item1.vue"
export default component.exports